<template>
  <div class="page">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="充值记录" name="first">
        <div class="aside">
          <div class="top" style="margin-right:20px;">
            <span style="padding-right:10px;">充值状态</span>
            <el-select v-model="value" placeholder="请选择" @change="change">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" placeholder="全部"></el-option>
            </el-select>
          </div>
          <div class="top">
            <span>选择时间：</span>
            <el-date-picker @change="timechange" v-model="value2" value-format="timestamp" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"></el-date-picker>
          </div>
        </div>
        <el-table :data="tableData" border style="width: 100%;" :cell-style="{ 'text-align': 'center' }" :header-cell-style="{background:'#f5f7fa',color:'#606266', 'text-align': 'center'}">
          <el-table-column prop="created_at" label="充值时间" width="240"></el-table-column>
          <el-table-column prop="money" label="充值金额" width="240"></el-table-column>
          <el-table-column label="充值状态" width="240">
            <template slot-scope="scope">
              <span v-show="tableData[scope.$index].status == 1">充值成功</span>
              <span v-show="tableData[scope.$index].status == 2">充值失败</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <span style="color:#96a9e9;" @click="detail(scope.$index)">详情</span>
              <el-popconfirm title="确定删除吗？" @confirm="confirmdel" v-show="false">
                <span style="color:red;" slot="reference" @click="del(scope.$index)">删除</span>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentpage" :page-size="pagesize" layout="total,  prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="付款记录" name="second">
        <div class="aside">
          <div class="top" style="margin-right:20px;">
            <span style="padding-right:10px;">发送状态</span>
            <el-select v-model="values" placeholder="请选择" @change="changestatus">
              <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value" placeholder="请选择"></el-option>
            </el-select>
          </div>
          <div class="top">
            <span>选择时间：</span>
            <el-date-picker @change="timechanges" v-model="valuetwo" value-format="timestamp" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"></el-date-picker>
          </div>
        </div>
        <el-table :data="tablist" border style="width: 100%;" :cell-style="{ 'text-align': 'center' }" :header-cell-style="{background:'#f5f7fa',color:'#606266', 'text-align': 'center'}">
          <el-table-column prop="alias_name" label="姓名" width="200"></el-table-column>
          <el-table-column label="支付类型" width="200">
            <template slot-scope="scope">
              <span v-show="tablist[scope.$index].type == 1">直接付款</span>
              <span v-show="tablist[scope.$index].type == 2">文件付款</span>
            </template>
          </el-table-column>
          <el-table-column prop="money" label="支付金额" width="200"></el-table-column>
          <el-table-column prop="created_at" label="发送时间" width="200"></el-table-column>
          <el-table-column label="状态" width="200">
            <template slot-scope="scope">
              <span v-show="tablist[scope.$index].status == 2">付款成功</span>
              <span v-show="tablist[scope.$index].status == 1">付款中</span>
              <span v-show="tablist[scope.$index].status == 3">付款失败</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <span style="color:#96a9e9;" @click="details(scope.$index)">详情</span>
              <el-popconfirm title="确定删除吗？" @confirm="confirmdels" v-show="false">
                <span style="color:red;" slot="reference" @click="dels(scope.$index)">删除</span>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @size-change="handleSizeChanges" @current-change="handleCurrentChanges" :current-page="page" :page-size="limit" layout="total,  prev, pager, next, jumper" :total="count"></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="收款记录" name="third">
        <collection></collection>
      </el-tab-pane>
      <el-tab-pane label="红包记录" name="fourth">
        <redrecord></redrecord>
      </el-tab-pane>
      <el-tab-pane label="提现记录" name="record">
        <withdraw></withdraw>
      </el-tab-pane>
      <el-tab-pane label="数据统计" name="statistics">
        <datastatics></datastatics>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="充值详情" :visible.sync="centerDialogVisible" width="30%" center>
      <div style="margin-left:20px;">
        <div>
          <span style="padding-right:10px;">充值金额</span>
          <span style="color:red;">
            ￥
            <span style="font-size:15px;">{{detaildata.money}}</span>
          </span>
        </div>
        <div style="margin:10px 0;">
          <span style="padding-right:10px;">支付方式</span>
          <span>{{detaildata.mark}}</span>
        </div>
        <div>
          <span style="padding-right:10px;">充值时间</span>
          <span>{{detaildata.created_at}}</span>
        </div>
        <div style="margin:10px 0;">
          <span style="padding-right:10px;">充值状态</span>
          <span v-show="detaildata.status == 1">成功</span>
          <span v-show="detaildata.status == 2">失败</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="付款详情" :visible.sync="paymentflag" width="60%" center>
      <div style="margin-left:20px;">
        <div>
          <span style="padding-right:10px;">付款总金额</span>
          <span style="color:red;">
            ￥
            <span style="font-size:15px;">{{paymentlist.money}}</span>
          </span>
        </div>
        <div style="margin:10px 0;">
          <span style="padding-right:10px;">付款方式</span>
          <span v-show="paymentlist.type == 1">直接付款</span>
          <span v-show="paymentlist.type == 2">文件付款</span>
        </div>
        <div class="detailsty" v-show="paymentlist.type == 2">
          <div class="detailsty_child">
            <img src="/img/合同图标.png" />
            <span style="padding-left:5px;">附件</span>
          </div>
          <a :href="paymentlist.file_url" download>下载</a>
        </div>
        <div>
          <span style="padding-right:10px;">付款时间</span>
          <span>{{paymentlist.created_at}}</span>
        </div>
        <div style="margin:10px 0;">
          <span style="padding-right:10px;">收款人员</span>
          <span>共{{paymentlist.count}}人</span>
        </div>
        <el-table style="width:100%" max-height="150" :data="paymentlist.data" :border="false" :cell-style="{ 'text-align': 'center' }" :header-cell-style="{background:'#f5f7fa',color:'#606266', 'text-align': 'center'}">
          <el-table-column prop="user_name" label="收款人" width="100"></el-table-column>
          <el-table-column prop="money" label="金额" width="100"></el-table-column>
          <el-table-column prop="content" label="备注" width="100"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span style="color:blue;">主页</span>
              <span style="color:blue;padding:0 10px;" @click="agree(scope.$index)" v-show="paymentlist.data[scope.$index].status == 1">用户同意</span>
              <span style="color:blue;" @click="refused(scope.$index)" v-show="paymentlist.data[scope.$index].status == 1">用户拒绝</span>
              <span style="color:blue;padding:0 10px;" v-show="paymentlist.data[scope.$index].status == 2" @click="agreetwo(scope.$index)">主管同意</span>
              <span style="color:blue;" v-show="paymentlist.data[scope.$index].status == 2" @click="refusedtwo(scope.$index)">主管拒绝</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="paymentflag = false">取 消</el-button>
        <el-button type="primary" @click="paymentflag = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  dealpaylist,
  dealpayinfo,
  dealpaydel,
  dealsalaryList,
  dealsalaryInfo,
  dealsalaryDel,
  moniadd,
  salarytwoClick,
  redpackList
} from "@/api/login/login";
import collection from "./collection-record";
import redrecord from "./redenvelopeto-record";
import withdraw from "./withdraw-record";
import datastatics from "./data-statistics";
export default {
  data () {
    return {
      valuetwo: "",
      values: "",
      paymentflag: false,
      centerDialogVisible: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
      value2: "",
      value: "",
      options: [
        {
          value: "0",
          label: "全部"
        },
        {
          value: "1",
          label: "成功"
        },
        {
          value: "2",
          label: "失败"
        }
      ],
      option: [
        {
          value: "0",
          label: "全部"
        },
        {
          value: "1",
          label: "发送中"
        },
        {
          value: "2",
          label: "完成"
        },
        {
          value: "3",
          label: "取消"
        }
      ],
      pagesize: 5,
      currentpage: 1,
      activeName: "first",
      tableData: [],
      i: 0,
      timestart: "",
      timeend: "",
      detaildata: {},
      delindex: "",
      total: -1,
      tablist: [],
      paymentlist: {},
      paydelindex: "",
      limit: 5,
      page: 1,
      count: -1,
      timeone: "",
      timetwo: "",
      ids: "",
      isShow: true
    };
  },
  mounted () { },
  created () {
    this.getlist();
  },
  methods: {
    //主管同意
    agreetwo (index) {
      let list = [];
      list.push(this.paymentlist.data[index].user_app_id);
      let data = {
        user_app_id: list,
        id: this.paymentlist.id,
        status: 3
      };
      salarytwoClick(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "确认成功"
          });
          let data = {
            id: this.tablist[this.ids].id
          };
          dealsalaryInfo(data).then(res => {
            this.paymentlist = res.data;
          });
          this.getsalarylist()
        } else {
          this.$message({
            type: "warning",
            message: "确认失败"
          });
        }
      });
    },
    //用户同意
    agree (index) {
      let list = [];
      list.push(this.paymentlist.data[index].user_app_id);
      let data = {
        user_app_id: list,
        id: this.paymentlist.id,
        status: 2
      };
      moniadd(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "确认成功"
          });
          let data = {
            id: this.tablist[this.ids].id
          };
          dealsalaryInfo(data).then(res => {
            this.paymentlist = res.data;
          });
          this.getsalarylist();
        } else {
          this.$message({
            type: "warning",
            message: "确认失败"
          });
        }
      });
    },
    //主管拒绝
    refusedtwo (index) {
      let list = [];
      list.push(this.paymentlist.data[index].user_app_id);
      let data = {
        user_app_id: list,
        id: this.paymentlist.id,
        status: 5,
        dmark: "不同意"
      };
      salarytwoClick(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "拒绝成功"
          });
          let data = {
            id: this.tablist[this.ids].id
          };
          dealsalaryInfo(data).then(res => {
            this.paymentlist = res.data;
          });
          this.getsalarylist();
        } else {
          this.$message({
            type: "warning",
            message: "拒绝失败"
          });
        }
      });
    },
    //用户拒绝
    refused (index) {
      let list = [];
      list.push(this.paymentlist.data[index].user_app_id);
      let data = {
        user_app_id: list,
        id: this.paymentlist.id,
        status: 4,
        mark: "不同意"
      };
      moniadd(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "拒绝成功"
          });
          let data = {
            id: this.tablist[this.ids].id
          };
          dealsalaryInfo(data).then(res => {
            this.paymentlist = res.data;
          });
          this.getsalarylist();
        } else {
          this.$message({
            type: "warning",
            message: "拒绝失败"
          });
        }
      });
    },
    //付款记录详情
    details (index) {
      this.ids = index;
      this.paymentflag = true;
      let data = {
        id: this.tablist[index].id
      };
      dealsalaryInfo(data).then(res => {
        this.paymentlist = res.data;
      });
    },
    //付款记录删除
    dels (index) {
      this.paydelindex = index;
    },
    //详情
    detail (index) {
      this.centerDialogVisible = true;
      let data = {
        id: this.tableData[index].id
      };
      dealpayinfo(data).then(res => {
        this.detaildata = res.data;
      });
    },
    //确认删除付款记录
    confirmdels () {
      dealsalaryDel({ id: this.tablist[this.paydelindex].id }).then(res => {
        if (res.code == 200) {
          this.tablist.splice(this.paydelindex, 1);
          this.$message({
            type: "success",
            message: "删除成功"
          });
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    //确认删除充值记录
    confirmdel () {
      dealpaydel({ id: this.tableData[this.delindex].id }).then(res => {
        if (res.code == 200) {
          this.tableData.splice(this.delindex, 1);
          this.$message({
            type: "success",
            message: "删除成功"
          });
        }
      });
    },
    del (index) {
      this.delindex = index;
    },
    //选择时间
    timechanges (e) {
      this.timeone = e[0] / 1000;
      this.timetwo = e[1] / 1000;
      if (this.i == 0) {
        let data = {
          start_time: this.timeone,
          end_time: this.timetwo,
          limit: this.limit,
          page: this.page
        };
        dealsalaryList(data).then(res => {
          this.tablist = res.data.data;
          this.count = res.data.total;
        });
      } else {
        let data = {
          status: this.i,
          start_time: this.timeone,
          end_time: this.timetwo,
          limit: this.limit,
          page: this.page
        };
        dealsalaryList(data).then(res => {
          this.tablist = res.data.data;
          this.count = res.data.total;
        });
      }
    },
    //选择时间
    timechange (e) {
      this.timestart = e[0] / 1000;
      this.timeend = e[1] / 1000;
      if (this.i == 0) {
        let data = {
          start_time: this.timestart,
          end_time: this.timeend,
          limit: this.pagesize,
          page: this.currentpage
        };
        dealpaylist(data).then(res => {
          this.tableData = res.data.data;
          this.total = res.data.total;
        });
      } else {
        let data = {
          status: this.i,
          start_time: this.timestart,
          end_time: this.timeend,
          limit: this.pagesize,
          page: this.currentpage
        };
        dealpaylist(data).then(res => {
          this.tableData = res.data.data;
          this.total = res.data.total;
        });
      }
    },
    changestatus (e) {
      this.i = e;
      if (e == 0) {
        this.getsalarylist();
      } else {
        let data = {
          limit: this.limit,
          page: this.page,
          status: e
        };
        dealsalaryList(data).then(res => {
          this.tablist = res.data.data;
          this.count = res.data.total;
        });
      }
    },
    change (e) {
      this.i = e;
      if (e == 0) {
        this.getlist();
      } else {
        let data = {
          limit: this.pagesize,
          page: this.currentpage,
          status: e
        };
        dealpaylist(data).then(res => {
          this.tableData = res.data.data;
          this.total = res.data.total;
        });
      }
    },
    //付款记录分页
    handleSizeChanges (val) {
      this.limit = val;
      this.getsalarylist();
    },
    handleCurrentChanges (val) {
      this.page = val;
      if (this.i == 0) {
        this.getsalarylist();
      } else {
        let data = {
          limit: this.limit,
          page: this.page,
          status: this.i
        };
        dealsalaryList(data).then(res => {
          this.tablist = res.data.data;
          this.count = res.data.total;
        });
      }
    },
    //充值记录分页
    handleSizeChange (val) {
      this.pagesize = val;
      this.getlist();
    },
    handleCurrentChange (val) {
      this.currentpage = val;
      if (this.i == 0) {
        this.getlist();
      } else {
        let data = {
          limit: this.pagesize,
          page: this.currentpage,
          status: this.i
        };
        dealpaylist(data).then(res => {
          this.tableData = res.data.data;
          this.total = res.data.total;
        });
      }
    },
    //付款记录
    getsalarylist () {
      let data = {
        limit: this.limit,
        page: this.page
      };
      dealsalaryList(data).then(res => {
        this.tablist = res.data.data;
        this.count = res.data.total;
      });
    },
    //充值记录
    getlist () {
      let data = {
        limit: this.pagesize,
        page: this.currentpage
      };
      dealpaylist(data).then(res => {
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    handleClick (tab, event) {
      this.value2 = "";
      this.i = 0;
      if (tab.index == 0) {
        this.getlist();
      }
      if (tab.index == 1) {
        this.getsalarylist();
      }
    }
  },
  components: { collection, redrecord, withdraw, datastatics }
};
</script>

<style lang='scss' scoped>
.page {
  .aside {
    display: flex;
    align-items: center;
    margin: 20px 0;
    .top {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .detailsty {
    .detailsty_child {
      display: flex;
      align-items: center;
      img {
        width: 25px;
        height: 25px;
      }
    }
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px;
    border: 1px #ccc solid;
    width: 200px;
    height: 30px;
    border-radius: 7px;
  }

  height: auto !important;
  .block {
    display: flex;
    justify-content: center;
    margin-top: 100px;
    padding-bottom: 10px;
  }
}
</style>
